import { Plus, X } from "lucide-react";
import { FIELD_CLASS, LABEL_CLASS } from "./shared";

// Key/value specification rows shown in the product's Specifications table.
export const SpecsSection = ({ form, newSpecKey, setNewSpecKey, newSpecValue, setNewSpecValue, addSpec, removeSpec, updateSpec }) => (
  <div>
    <span className={LABEL_CLASS}>Specifications</span>
    <ul className="mt-2 space-y-2">
      {form.specs.map(([k, v], i) => (
        <li key={i} data-testid={`admin-spec-${i}`} className="flex items-center gap-2 text-white/80 text-sm">
          <input
            data-testid={`admin-spec-edit-key-${i}`}
            value={k}
            onChange={(e) => updateSpec(i, 0, e.target.value)}
            className={FIELD_CLASS + " mt-0 flex-1"}
            placeholder="Label"
          />
          <input
            data-testid={`admin-spec-edit-value-${i}`}
            value={v}
            onChange={(e) => updateSpec(i, 1, e.target.value)}
            className={FIELD_CLASS + " mt-0 flex-1"}
            placeholder="Value"
          />
          <button type="button" onClick={() => removeSpec(i)} data-testid={`admin-spec-remove-${i}`} className="text-white/50 hover:text-red-400 shrink-0">
            <X size={14} />
          </button>
        </li>
      ))}
    </ul>
    <div className="flex gap-2 mt-2">
      <input data-testid="admin-spec-key-input" value={newSpecKey} onChange={(e) => setNewSpecKey(e.target.value)} className={FIELD_CLASS + " mt-0"} placeholder="Label (e.g. Weight)" />
      <input data-testid="admin-spec-value-input" value={newSpecValue} onChange={(e) => setNewSpecValue(e.target.value)} className={FIELD_CLASS + " mt-0"} placeholder="Value (e.g. 45kg)" />
      <button type="button" onClick={addSpec} data-testid="admin-spec-add" className="btn-secondary shrink-0">
        <Plus size={14} />
      </button>
    </div>
  </div>
);
